import Vue from 'vue'
export default (data) => {
    return Vue.Api.Get(`${data.API_URL}AllCurencies/convertFilterPrice?` +
        `SourceRateKey=${data.oldRateKey}` +
        `&TargetRateKey=${data.newRateKey}` +
        `&MinPrice=${data.minPrice ? data.minPrice : 0}` +
        `&MaxPrice=${data.maxPrice ? data.maxPrice : 0}` +
        `&_=${data.date}`);
}

